import React from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { getUserProfilePic } from "./helper/GeneralHelper";
import DefaultAvatar from "./common/DefaultAvatar";
import { Home } from "lucide-react";

const Appfooter = () => {
  const loggedUserInfo = useSelector((state) => state.authentication);

  return (
    <div className="app-footer border-0 shadow-lg bg-light-black-gradient">
      <Link to="/" className="nav-content-bttn nav-center rc-nav-icon-btn">
        <Home size={22} />
      </Link>
      <Link to="/profile" className="nav-content-bttn mt-3">
        <DefaultAvatar
          id={loggedUserInfo?.userData?._id}
          userName={loggedUserInfo?.userData?.name}
        >
          {loggedUserInfo?.userData?.profilePicture ? (
            <figure
              alt={loggedUserInfo?.userData?.name}
              title={loggedUserInfo?.userData?.name}
              className="avatar z-index-1 user-profile-figure"
              style={{
                background: getUserProfilePic(
                  loggedUserInfo?.userData?._id,
                  loggedUserInfo?.userData?.profilePicture,
                  true,
                  "0% 0% / cover no-repeat"
                ),
              }}
            ></figure>
          ) : null}
        </DefaultAvatar>
      </Link>
    </div>
  );
};

export default Appfooter;
